import styled from 'styled-components'
import bgImgDesktop from './assets/bg-desktop.png'
import bgImgMobile from './assets/bg-mobile.png'

export const Container = styled.div`
  background-color: #7200D6;
  background-image: url(${bgImgDesktop});
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  overflow: hidden;

  @media (max-width: 911px) {
    background-position: center;
    background-image: url(${bgImgMobile});
    background-position: bottom;
  }
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-inline: auto;
  max-width: 1366px;
  padding: 24px 24px 10px;
  width: 100%;

  & > figure {
    max-width: 626px;

    & > img {
      width: 100%;
    }
  }

  @media (max-width: 911px) {
    flex-direction: column;
  }

  @media (max-width: 568px) {
    padding-top: 40px;

    & > figure {
      margin: 0 -20% -32%;
    }
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 490px;
  width: 100%;

  & > h1 {
    color: #FFF;
    font-size: 2rem;
    font-weight: 500;

    @media (min-width: 912px) {
      max-width: 72%;
    }

    @media (min-width: 568px) and (max-width: 911px) {
      max-width: 72%;
    }
  }

  & > p {
    color: #FFF;
    font-size: 1.125rem;
    font-weight: 600;
  }
`
